import React from 'react'
import { AppAvatar } from 'components/Common/AppAvatar/AppAvatar.component'
import { getInitials } from 'components/Chat/helper'
import { ChannelMemberResponse } from 'stream-chat'
import type { StreamChatGenerics } from '../../types'

interface GroupMembersDisplayProps {
  members: ChannelMemberResponse<StreamChatGenerics>[]
  totalCount: number
  onClick: () => void
}

const GroupMembersDisplay: React.FC<GroupMembersDisplayProps> = ({
  members,
  totalCount,
  onClick,
}) => {
  // Only show for group channels (more than 1 member excluding current user)
  if (members.length <= 1) {
    return null
  }

  // Get first 3 members to display
  const displayMembers = members.slice(0, 3)

  return (
    <div
      className="flex items-center gap-2 cursor-pointer hover:bg-app-grey-10 px-2 py-1 rounded-lg transition-colors duration-150 border border-app-grey-25"
      onClick={onClick}
    >
      {/* Stacked avatars */}
      <div className="flex -space-x-2">
        {displayMembers.map((member, index) => (
          <div
            key={member.user?.id || index}
            className="ring-2 ring-app-white-100 rounded-full"
            style={{ zIndex: displayMembers.length - index }}
          >
            <AppAvatar
              size="sm"
              type="mixed"
              shape="Rounded"
              text={getInitials({
                firstName: (member.user as any)?.firstName || '',
                lastName: (member.user as any)?.lastName || '',
              })}
            />
          </div>
        ))}
      </div>
      {/* Member count */}
      <span className="text-sm font-medium text-app-grey-70">{totalCount}</span>
    </div>
  )
}

export default GroupMembersDisplay
